"use client";

import { PlusCircle, Send, PenTool, FileUp, ArrowRightLeft } from "lucide-react";

interface InvestmentActivityLogWidgetProps {
  className?: string;
}

// Mock data in chronological order (oldest first)
const activityLog = [
  {
    id: "1",
    type: "created",
    title: "Inversion creada",
    actor: "Ana Martinez",
    fullTimestamp: "15 de enero de 2025, 09:30",
    metadata: [{ label: "Importe", value: "25.000,00 \u20ac" }],
    icon: PlusCircle,
  },
  {
    id: "2",
    type: "financing_contract_sent",
    title: "Contrato de financiacion enviado",
    actor: "Ana Martinez",
    fullTimestamp: "16 de enero de 2025, 11:15",
    metadata: [],
    icon: Send,
  },
  {
    id: "3",
    type: "contract_signed",
    title: "Contrato firmado",
    actor: "Carlos Lopez",
    fullTimestamp: "17 de enero de 2025, 14:22",
    metadata: [{ label: "Progreso", value: "1/2 firmas" }],
    icon: PenTool,
  },
  {
    id: "4",
    type: "contract_signed",
    title: "Contrato firmado",
    actor: "Producciones Norte, SL",
    fullTimestamp: "18 de enero de 2025, 10:05",
    metadata: [{ label: "Progreso", value: "2/2 firmas" }],
    icon: PenTool,
  },
  {
    id: "5",
    type: "document_uploaded",
    title: "Documento subido",
    actor: "Ana Martinez",
    fullTimestamp: "19 de enero de 2025, 16:45",
    metadata: [{ label: "Tipo", value: "Comprobante de Pago" }],
    icon: FileUp,
  },
  {
    id: "6",
    type: "state_changed",
    title: "Estado cambiado",
    actor: "Ana Martinez",
    fullTimestamp: "20 de enero de 2025, 09:00",
    metadata: [{ label: "Cambio", value: "En Financiacion \u2192 Financiado" }],
    icon: ArrowRightLeft,
  },
];

export function InvestmentActivityLogWidget({ className }: InvestmentActivityLogWidgetProps) {
  return (
    <div className={className}>
      {/* Card Container - narrow vertical card */}
      <div className="w-80 bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        {/* Header */}
        <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900">Actividad</h3>
          <span className="text-[11px] text-gray-500">Inversion #INV-2025-0842</span>
        </div>

        {/* Timeline */}
        <div className="px-4 py-3">
          <div className="relative">
            {activityLog.map((activity, index) => {
              const Icon = activity.icon;
              const isLast = index === activityLog.length - 1;

              return (
                <div key={activity.id} className="relative pb-4">
                  {/* Connector Line */}
                  {!isLast && (
                    <div className="absolute left-3.5 top-7 bottom-[-16px] w-px bg-gray-200" />
                  )}

                  {/* Activity Item */}
                  <div className="flex gap-3">
                    {/* Icon Container */}
                    <div className="w-7 h-7 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0 relative z-10">
                      <Icon size={14} className="text-zinc-700" />
                    </div>

                    {/* Content */}
                    <div className="flex-1 min-w-0">
                      {/* Title */}
                      <span className="text-xs font-semibold text-gray-900">{activity.title}</span>

                      {/* Actor + Full Timestamp */}
                      <div className="text-[10px] text-gray-500 mt-1">
                        {activity.actor} <span className="text-gray-400">&bull;</span>{" "}
                        {activity.fullTimestamp}
                      </div>

                      {/* Metadata Lines */}
                      {activity.metadata && activity.metadata.length > 0 && (
                        <div className="mt-1.5 space-y-0.5">
                          {activity.metadata.map((meta, idx) => (
                            <div key={idx} className="text-[10px]">
                              <span className="text-gray-500">{meta.label}:</span>{" "}
                              <span className="text-gray-700">{meta.value}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Footer hint */}
        <div className="px-4 py-2 bg-gray-50 border-t border-gray-100">
          <span className="text-[10px] text-gray-400 font-medium">
            Historial completo disponible
          </span>
        </div>
      </div>
    </div>
  );
}

export default InvestmentActivityLogWidget;
